/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { AutoStakingStatusFragmentFragmentDoc } from "./AutoStakingStatusFragment.service.graphql-gen";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type GetSettingsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetSettingsQuery = {
	__typename?: "Query";
	settings: { __typename?: "Settings"; autoStake: { __typename?: "AutoStaking"; enabled: boolean } };
};

export const GetSettingsDocument = gql`
	query GetSettings {
		settings {
			autoStake {
				...AutoStakingStatusFragment
			}
		}
	}
	${AutoStakingStatusFragmentFragmentDoc}
`;

@Injectable({
	providedIn: "root"
})
export class GetSettingsGQLService extends Apollo.Query<GetSettingsQuery, GetSettingsQueryVariables> {
	document = GetSettingsDocument;
	client = "staking";
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
